module.exports = __webpack_public_path__ + "img/dribbble-square.39719e0a.svg";